import PropTypes from 'prop-types';
import React from 'react';

import { DorMeasurementFieldNames, MeasurementDisplayTypes } from '@powdr/constants';
import { useLiftsMeasurements } from '@powdr/hooks';

import { CircularGraph } from './circular-graph';
import {
  TextMeasurementSplit,
  TextMeasurementSplitLarge,
  TextMeasurementSplitSmall,
} from './styles';
import { TextMeasurement } from './text-measurement';

export const Lifts = ({
  measurementLabel = null,
  measurementDisplayType = null,
  ignoreLiftTypes = null,
  includeInOpenCount = null,
  icon = null,
  season = null,
  sectors = [],
  parentColorProfile = null,
}) => {
  const measurementData = useLiftsMeasurements(
    ignoreLiftTypes,
    includeInOpenCount,
    sectors,
    season,
  );

  if (!measurementData) return null;

  return (
    <>
      {(measurementDisplayType === MeasurementDisplayTypes.CIRCULAR_GRAPH) && (
        <CircularGraph
          colorProfile={parentColorProfile}
          label={measurementLabel}
          openVal={measurementData[DorMeasurementFieldNames.OPEN]}
          totalVal={measurementData[DorMeasurementFieldNames.TOTAL]}
        />
      )}
      {(measurementDisplayType === MeasurementDisplayTypes.TEXT
        || measurementDisplayType === MeasurementDisplayTypes.TEXT_LARGE) && (
        <TextMeasurement
          measurementDisplayType={measurementDisplayType}
          label={measurementLabel}
          icon={icon}
          colorProfile={parentColorProfile}
        >
          <TextMeasurementSplit className="split">
            <TextMeasurementSplitLarge className="split-large">
              {measurementData[DorMeasurementFieldNames.OPEN]}
            </TextMeasurementSplitLarge>
            <TextMeasurementSplitSmall className="split-small">
              {`/${measurementData[DorMeasurementFieldNames.TOTAL]}`}
            </TextMeasurementSplitSmall>
          </TextMeasurementSplit>
        </TextMeasurement>
      )}
    </>
  );
};

Lifts.propTypes = {
  parentColorProfile: PropTypes.string,
  measurementLabel: PropTypes.string,
  measurementDisplayType: PropTypes.string,
  includeInOpenCount: PropTypes.arrayOf(PropTypes.string),
  ignoreLiftTypes: PropTypes.arrayOf(PropTypes.string),
  sectors: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    uuid: PropTypes.string,
  })),
  icon: PropTypes.string,
  season: PropTypes.string,
};
